import React from 'react';

const benefits = [
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    title: 'Verified, Trusted Spaces',
    description: 'Every gym, studio and trainer on our platform is verified to ensure they provide a genuine women-only or women-focused environment.',
    highlighted: false,
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
      </svg>
    ),
    title: 'Safe & Comfort Focused',
    description: 'We prioritize spaces where women feel physically and emotionally safe. No intimidation, no judgment—just support.',
    highlighted: true,
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    ),
    title: 'Always Women Only',
    description: 'Filter for 100% women-only gyms and classes. Know before you go. No surprises, just comfort and community.',
    highlighted: false,
  },
];

const Benefits = () => {
  return (
    <section className="py-20 bg-[#f5f2f0]">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2b262e] text-center mb-12">
          Why Choose Female Fitness Finder?
        </h2>

        <div className="grid md:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className={`p-8 rounded-[20px] transition-transform hover:-translate-y-1 ${
                benefit.highlighted
                  ? 'bg-[#8a7490] text-white'
                  : 'bg-white text-[#2b262e]'
              }`}
            >
              <div className={`mb-4 ${benefit.highlighted ? 'text-white' : 'text-[#8a7490]'}`}>
                {benefit.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3">{benefit.title}</h3>
              <p className={`text-sm leading-relaxed ${benefit.highlighted ? 'text-white/90' : 'text-[#6e6672]'}`}>
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
